"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");
/**
 * A wrapper around an RDF source that emits totalItems metadata *before* the end event.
 */


var RdfSourceMetadata =
/*#__PURE__*/
function () {
  function RdfSourceMetadata(source) {
    _classCallCheck(this, RdfSourceMetadata);

    this.source = source;
  }

  _createClass(RdfSourceMetadata, [{
    key: "match",
    value: function match(subject, predicate, object, graph) {
      var _this = this;

      var streamOut = new stream_1.Readable({
        objectMode: true
      });

      streamOut._read = function () {
        streamOut._read = function () {
          return;
        };

        var streamIn = _this.source.match(subject, predicate, object, graph);

        var totalItems = 0;
        streamIn.on('error', function (error) {
          streamOut.emit('error', error);
        });
        streamIn.on('data', function (quad) {
          totalItems++;
          streamOut.push(quad);
        });
        streamIn.on('end', function () {
          streamOut.emit('metadata', {
            totalItems: totalItems
          });
          streamOut.push(null);
        });
      };

      return streamOut;
    }
  }]);

  return RdfSourceMetadata;
}();

exports.RdfSourceMetadata = RdfSourceMetadata;